import {app} from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.policies.authentication-access-policies.edit', {
        url: '/:policyId/edit',
        views: {'@company.policies': 'companyPoliciesAuthenticationAccessPoliciesEdit'},
        resolve: {policy},
    });
}

/** @ngInject */
function policy($stateParams, policies) {
    return policies.find(p => p.id === $stateParams.policyId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/authentication-access-policies/edit-policy/edit-policy.state.js